import { coreApi } from "./coreApi";

export const permissionsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getPermissions: builder.query({
      query: () => ({
        url: "/permissions/user-permissions/create",
        method: "GET",
      }),
    }),
    giveUserPermissions: builder.mutation({
      query: (body) => ({
        url: `/permissions/user-permissions/store`,
        method: "POST",
        body,
      }),
    }),
    revokePermissions: builder.mutation({
      query: (body) => ({
        url: `/permissions/user-permissions/delete`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useGiveUserPermissionsMutation,
  useRevokePermissionsMutation,
} = permissionsApi;
